/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LivekitEgressTemplateRouteImport } from './routes/livekit-egress-template'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedShareRouteImport } from './routes/_protected/share'
import { Route as ProtectedProfileRouteImport } from './routes/_protected/profile'
import { Route as ProtectedJoinRouteImport } from './routes/_protected/join'
import { Route as ProtectedCreditsRouteImport } from './routes/_protected/credits'
import { Route as ProtectedAdminRouteRouteImport } from './routes/_protected/admin/route'
import { Route as ProtectedPitchesIndexRouteImport } from './routes/_protected/pitches/index'
import { Route as ProtectedAdminIndexRouteImport } from './routes/_protected/admin/index'
import { Route as ProtectedUsersIdRouteImport } from './routes/_protected/users/$id'
import { Route as ProtectedSTokenRouteImport } from './routes/_protected/s/$token'
import { Route as ProtectedPitchesNewRouteImport } from './routes/_protected/pitches/new'
import { Route as ProtectedPitchesPitchIdRouteImport } from './routes/_protected/pitches/$pitchId'
import { Route as ProtectedInvestorsIdRouteImport } from './routes/_protected/investors/$id'
import { Route as ProtectedAdminUsersIndexRouteImport } from './routes/_protected/admin/users/index'
import { Route as ProtectedAdminStartupsIndexRouteImport } from './routes/_protected/admin/startups/index'
import { Route as ProtectedAdminPrescreensIndexRouteImport } from './routes/_protected/admin/prescreens/index'
import { Route as ProtectedAdminOnboardingIndexRouteImport } from './routes/_protected/admin/onboarding/index'
import { Route as ProtectedAdminInvestorsIndexRouteImport } from './routes/_protected/admin/investors/index'
import { Route as ProtectedAdminFeedbackIndexRouteImport } from './routes/_protected/admin/feedback/index'
import { Route as ProtectedAdminEvaluationsIndexRouteImport } from './routes/_protected/admin/evaluations/index'
import { Route as ProtectedAdminEmailsIndexRouteImport } from './routes/_protected/admin/emails/index'
import { Route as ProtectedAdminDataroomsIndexRouteImport } from './routes/_protected/admin/datarooms/index'
import { Route as ProtectedAdminUsersIdRouteImport } from './routes/_protected/admin/users/$id'
import { Route as ProtectedAdminStartupsIdRouteImport } from './routes/_protected/admin/startups/$id'
import { Route as ProtectedAdminPrescreensIdRouteImport } from './routes/_protected/admin/prescreens/$id'
import { Route as ProtectedAdminOnboardingIdRouteImport } from './routes/_protected/admin/onboarding/$id'
import { Route as ProtectedAdminInvestorsIdRouteImport } from './routes/_protected/admin/investors/$id'
import { Route as ProtectedAdminEvaluationsIdRouteImport } from './routes/_protected/admin/evaluations/$id'
import { Route as ProtectedAdminEmailsIdRouteImport } from './routes/_protected/admin/emails/$id'
import { Route as ProtectedAdminDataroomsIdRouteImport } from './routes/_protected/admin/datarooms/$id'

const LivekitEgressTemplateRoute = LivekitEgressTemplateRouteImport.update({
  id: '/livekit-egress-template',
  path: '/livekit-egress-template',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedShareRoute = ProtectedShareRouteImport.update({
  id: '/share',
  path: '/share',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedJoinRoute = ProtectedJoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCreditsRoute = ProtectedCreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminRouteRoute = ProtectedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPitchesIndexRoute = ProtectedPitchesIndexRouteImport.update({
  id: '/pitches/',
  path: '/pitches/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminIndexRoute = ProtectedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any)
const ProtectedUsersIdRoute = ProtectedUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSTokenRoute = ProtectedSTokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPitchesNewRoute = ProtectedPitchesNewRouteImport.update({
  id: '/pitches/new',
  path: '/pitches/new',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPitchesPitchIdRoute = ProtectedPitchesPitchIdRouteImport.update({
  id: '/pitches/$pitchId',
  path: '/pitches/$pitchId',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedInvestorsIdRoute = ProtectedInvestorsIdRouteImport.update({
  id: '/investors/$id',
  path: '/investors/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminUsersIndexRoute =
  ProtectedAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminStartupsIndexRoute =
  ProtectedAdminStartupsIndexRouteImport.update({
    id: '/startups/',
    path: '/startups/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminPrescreensIndexRoute =
  ProtectedAdminPrescreensIndexRouteImport.update({
    id: '/prescreens/',
    path: '/prescreens/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminOnboardingIndexRoute =
  ProtectedAdminOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminInvestorsIndexRoute =
  ProtectedAdminInvestorsIndexRouteImport.update({
    id: '/investors/',
    path: '/investors/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminFeedbackIndexRoute =
  ProtectedAdminFeedbackIndexRouteImport.update({
    id: '/feedback/',
    path: '/feedback/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminEvaluationsIndexRoute =
  ProtectedAdminEvaluationsIndexRouteImport.update({
    id: '/evaluations/',
    path: '/evaluations/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminEmailsIndexRoute =
  ProtectedAdminEmailsIndexRouteImport.update({
    id: '/emails/',
    path: '/emails/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminDataroomsIndexRoute =
  ProtectedAdminDataroomsIndexRouteImport.update({
    id: '/datarooms/',
    path: '/datarooms/',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminUsersIdRoute = ProtectedAdminUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any)
const ProtectedAdminStartupsIdRoute =
  ProtectedAdminStartupsIdRouteImport.update({
    id: '/startups/$id',
    path: '/startups/$id',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminPrescreensIdRoute =
  ProtectedAdminPrescreensIdRouteImport.update({
    id: '/prescreens/$id',
    path: '/prescreens/$id',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminOnboardingIdRoute =
  ProtectedAdminOnboardingIdRouteImport.update({
    id: '/onboarding/$id',
    path: '/onboarding/$id',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminInvestorsIdRoute =
  ProtectedAdminInvestorsIdRouteImport.update({
    id: '/investors/$id',
    path: '/investors/$id',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminEvaluationsIdRoute =
  ProtectedAdminEvaluationsIdRouteImport.update({
    id: '/evaluations/$id',
    path: '/evaluations/$id',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)
const ProtectedAdminEmailsIdRoute = ProtectedAdminEmailsIdRouteImport.update({
  id: '/emails/$id',
  path: '/emails/$id',
  getParentRoute: () => ProtectedAdminRouteRoute,
} as any)
const ProtectedAdminDataroomsIdRoute =
  ProtectedAdminDataroomsIdRouteImport.update({
    id: '/datarooms/$id',
    path: '/datarooms/$id',
    getParentRoute: () => ProtectedAdminRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$slug': typeof SlugRoute
  '/livekit-egress-template': typeof LivekitEgressTemplateRoute
  '/admin': typeof ProtectedAdminRouteRouteWithChildren
  '/credits': typeof ProtectedCreditsRoute
  '/join': typeof ProtectedJoinRoute
  '/profile': typeof ProtectedProfileRoute
  '/share': typeof ProtectedShareRoute
  '/': typeof ProtectedIndexRoute
  '/investors/$id': typeof ProtectedInvestorsIdRoute
  '/pitches/$pitchId': typeof ProtectedPitchesPitchIdRoute
  '/pitches/new': typeof ProtectedPitchesNewRoute
  '/s/$token': typeof ProtectedSTokenRoute
  '/users/$id': typeof ProtectedUsersIdRoute
  '/admin/': typeof ProtectedAdminIndexRoute
  '/pitches': typeof ProtectedPitchesIndexRoute
  '/admin/datarooms/$id': typeof ProtectedAdminDataroomsIdRoute
  '/admin/emails/$id': typeof ProtectedAdminEmailsIdRoute
  '/admin/evaluations/$id': typeof ProtectedAdminEvaluationsIdRoute
  '/admin/investors/$id': typeof ProtectedAdminInvestorsIdRoute
  '/admin/onboarding/$id': typeof ProtectedAdminOnboardingIdRoute
  '/admin/prescreens/$id': typeof ProtectedAdminPrescreensIdRoute
  '/admin/startups/$id': typeof ProtectedAdminStartupsIdRoute
  '/admin/users/$id': typeof ProtectedAdminUsersIdRoute
  '/admin/datarooms': typeof ProtectedAdminDataroomsIndexRoute
  '/admin/emails': typeof ProtectedAdminEmailsIndexRoute
  '/admin/evaluations': typeof ProtectedAdminEvaluationsIndexRoute
  '/admin/feedback': typeof ProtectedAdminFeedbackIndexRoute
  '/admin/investors': typeof ProtectedAdminInvestorsIndexRoute
  '/admin/onboarding': typeof ProtectedAdminOnboardingIndexRoute
  '/admin/prescreens': typeof ProtectedAdminPrescreensIndexRoute
  '/admin/startups': typeof ProtectedAdminStartupsIndexRoute
  '/admin/users': typeof ProtectedAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/$slug': typeof SlugRoute
  '/livekit-egress-template': typeof LivekitEgressTemplateRoute
  '/credits': typeof ProtectedCreditsRoute
  '/join': typeof ProtectedJoinRoute
  '/profile': typeof ProtectedProfileRoute
  '/share': typeof ProtectedShareRoute
  '/': typeof ProtectedIndexRoute
  '/investors/$id': typeof ProtectedInvestorsIdRoute
  '/pitches/$pitchId': typeof ProtectedPitchesPitchIdRoute
  '/pitches/new': typeof ProtectedPitchesNewRoute
  '/s/$token': typeof ProtectedSTokenRoute
  '/users/$id': typeof ProtectedUsersIdRoute
  '/admin': typeof ProtectedAdminIndexRoute
  '/pitches': typeof ProtectedPitchesIndexRoute
  '/admin/datarooms/$id': typeof ProtectedAdminDataroomsIdRoute
  '/admin/emails/$id': typeof ProtectedAdminEmailsIdRoute
  '/admin/evaluations/$id': typeof ProtectedAdminEvaluationsIdRoute
  '/admin/investors/$id': typeof ProtectedAdminInvestorsIdRoute
  '/admin/onboarding/$id': typeof ProtectedAdminOnboardingIdRoute
  '/admin/prescreens/$id': typeof ProtectedAdminPrescreensIdRoute
  '/admin/startups/$id': typeof ProtectedAdminStartupsIdRoute
  '/admin/users/$id': typeof ProtectedAdminUsersIdRoute
  '/admin/datarooms': typeof ProtectedAdminDataroomsIndexRoute
  '/admin/emails': typeof ProtectedAdminEmailsIndexRoute
  '/admin/evaluations': typeof ProtectedAdminEvaluationsIndexRoute
  '/admin/feedback': typeof ProtectedAdminFeedbackIndexRoute
  '/admin/investors': typeof ProtectedAdminInvestorsIndexRoute
  '/admin/onboarding': typeof ProtectedAdminOnboardingIndexRoute
  '/admin/prescreens': typeof ProtectedAdminPrescreensIndexRoute
  '/admin/startups': typeof ProtectedAdminStartupsIndexRoute
  '/admin/users': typeof ProtectedAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$slug': typeof SlugRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/livekit-egress-template': typeof LivekitEgressTemplateRoute
  '/_protected/admin': typeof ProtectedAdminRouteRouteWithChildren
  '/_protected/credits': typeof ProtectedCreditsRoute
  '/_protected/join': typeof ProtectedJoinRoute
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/share': typeof ProtectedShareRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/investors/$id': typeof ProtectedInvestorsIdRoute
  '/_protected/pitches/$pitchId': typeof ProtectedPitchesPitchIdRoute
  '/_protected/pitches/new': typeof ProtectedPitchesNewRoute
  '/_protected/s/$token': typeof ProtectedSTokenRoute
  '/_protected/users/$id': typeof ProtectedUsersIdRoute
  '/_protected/admin/': typeof ProtectedAdminIndexRoute
  '/_protected/pitches/': typeof ProtectedPitchesIndexRoute
  '/_protected/admin/datarooms/$id': typeof ProtectedAdminDataroomsIdRoute
  '/_protected/admin/emails/$id': typeof ProtectedAdminEmailsIdRoute
  '/_protected/admin/evaluations/$id': typeof ProtectedAdminEvaluationsIdRoute
  '/_protected/admin/investors/$id': typeof ProtectedAdminInvestorsIdRoute
  '/_protected/admin/onboarding/$id': typeof ProtectedAdminOnboardingIdRoute
  '/_protected/admin/prescreens/$id': typeof ProtectedAdminPrescreensIdRoute
  '/_protected/admin/startups/$id': typeof ProtectedAdminStartupsIdRoute
  '/_protected/admin/users/$id': typeof ProtectedAdminUsersIdRoute
  '/_protected/admin/datarooms/': typeof ProtectedAdminDataroomsIndexRoute
  '/_protected/admin/emails/': typeof ProtectedAdminEmailsIndexRoute
  '/_protected/admin/evaluations/': typeof ProtectedAdminEvaluationsIndexRoute
  '/_protected/admin/feedback/': typeof ProtectedAdminFeedbackIndexRoute
  '/_protected/admin/investors/': typeof ProtectedAdminInvestorsIndexRoute
  '/_protected/admin/onboarding/': typeof ProtectedAdminOnboardingIndexRoute
  '/_protected/admin/prescreens/': typeof ProtectedAdminPrescreensIndexRoute
  '/_protected/admin/startups/': typeof ProtectedAdminStartupsIndexRoute
  '/_protected/admin/users/': typeof ProtectedAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$slug'
    | '/livekit-egress-template'
    | '/admin'
    | '/credits'
    | '/join'
    | '/profile'
    | '/share'
    | '/'
    | '/investors/$id'
    | '/pitches/$pitchId'
    | '/pitches/new'
    | '/s/$token'
    | '/users/$id'
    | '/admin/'
    | '/pitches'
    | '/admin/datarooms/$id'
    | '/admin/emails/$id'
    | '/admin/evaluations/$id'
    | '/admin/investors/$id'
    | '/admin/onboarding/$id'
    | '/admin/prescreens/$id'
    | '/admin/startups/$id'
    | '/admin/users/$id'
    | '/admin/datarooms'
    | '/admin/emails'
    | '/admin/evaluations'
    | '/admin/feedback'
    | '/admin/investors'
    | '/admin/onboarding'
    | '/admin/prescreens'
    | '/admin/startups'
    | '/admin/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$slug'
    | '/livekit-egress-template'
    | '/credits'
    | '/join'
    | '/profile'
    | '/share'
    | '/'
    | '/investors/$id'
    | '/pitches/$pitchId'
    | '/pitches/new'
    | '/s/$token'
    | '/users/$id'
    | '/admin'
    | '/pitches'
    | '/admin/datarooms/$id'
    | '/admin/emails/$id'
    | '/admin/evaluations/$id'
    | '/admin/investors/$id'
    | '/admin/onboarding/$id'
    | '/admin/prescreens/$id'
    | '/admin/startups/$id'
    | '/admin/users/$id'
    | '/admin/datarooms'
    | '/admin/emails'
    | '/admin/evaluations'
    | '/admin/feedback'
    | '/admin/investors'
    | '/admin/onboarding'
    | '/admin/prescreens'
    | '/admin/startups'
    | '/admin/users'
  id:
    | '__root__'
    | '/$slug'
    | '/_protected'
    | '/livekit-egress-template'
    | '/_protected/admin'
    | '/_protected/credits'
    | '/_protected/join'
    | '/_protected/profile'
    | '/_protected/share'
    | '/_protected/'
    | '/_protected/investors/$id'
    | '/_protected/pitches/$pitchId'
    | '/_protected/pitches/new'
    | '/_protected/s/$token'
    | '/_protected/users/$id'
    | '/_protected/admin/'
    | '/_protected/pitches/'
    | '/_protected/admin/datarooms/$id'
    | '/_protected/admin/emails/$id'
    | '/_protected/admin/evaluations/$id'
    | '/_protected/admin/investors/$id'
    | '/_protected/admin/onboarding/$id'
    | '/_protected/admin/prescreens/$id'
    | '/_protected/admin/startups/$id'
    | '/_protected/admin/users/$id'
    | '/_protected/admin/datarooms/'
    | '/_protected/admin/emails/'
    | '/_protected/admin/evaluations/'
    | '/_protected/admin/feedback/'
    | '/_protected/admin/investors/'
    | '/_protected/admin/onboarding/'
    | '/_protected/admin/prescreens/'
    | '/_protected/admin/startups/'
    | '/_protected/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SlugRoute: typeof SlugRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LivekitEgressTemplateRoute: typeof LivekitEgressTemplateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/livekit-egress-template': {
      id: '/livekit-egress-template'
      path: '/livekit-egress-template'
      fullPath: '/livekit-egress-template'
      preLoaderRoute: typeof LivekitEgressTemplateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/share': {
      id: '/_protected/share'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ProtectedShareRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/join': {
      id: '/_protected/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof ProtectedJoinRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/credits': {
      id: '/_protected/credits'
      path: '/credits'
      fullPath: '/credits'
      preLoaderRoute: typeof ProtectedCreditsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin': {
      id: '/_protected/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ProtectedAdminRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pitches/': {
      id: '/_protected/pitches/'
      path: '/pitches'
      fullPath: '/pitches'
      preLoaderRoute: typeof ProtectedPitchesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin/': {
      id: '/_protected/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof ProtectedAdminIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/users/$id': {
      id: '/_protected/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof ProtectedUsersIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/s/$token': {
      id: '/_protected/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof ProtectedSTokenRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pitches/new': {
      id: '/_protected/pitches/new'
      path: '/pitches/new'
      fullPath: '/pitches/new'
      preLoaderRoute: typeof ProtectedPitchesNewRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pitches/$pitchId': {
      id: '/_protected/pitches/$pitchId'
      path: '/pitches/$pitchId'
      fullPath: '/pitches/$pitchId'
      preLoaderRoute: typeof ProtectedPitchesPitchIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/investors/$id': {
      id: '/_protected/investors/$id'
      path: '/investors/$id'
      fullPath: '/investors/$id'
      preLoaderRoute: typeof ProtectedInvestorsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin/users/': {
      id: '/_protected/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof ProtectedAdminUsersIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/startups/': {
      id: '/_protected/admin/startups/'
      path: '/startups'
      fullPath: '/admin/startups'
      preLoaderRoute: typeof ProtectedAdminStartupsIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/prescreens/': {
      id: '/_protected/admin/prescreens/'
      path: '/prescreens'
      fullPath: '/admin/prescreens'
      preLoaderRoute: typeof ProtectedAdminPrescreensIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/onboarding/': {
      id: '/_protected/admin/onboarding/'
      path: '/onboarding'
      fullPath: '/admin/onboarding'
      preLoaderRoute: typeof ProtectedAdminOnboardingIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/investors/': {
      id: '/_protected/admin/investors/'
      path: '/investors'
      fullPath: '/admin/investors'
      preLoaderRoute: typeof ProtectedAdminInvestorsIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/feedback/': {
      id: '/_protected/admin/feedback/'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof ProtectedAdminFeedbackIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/evaluations/': {
      id: '/_protected/admin/evaluations/'
      path: '/evaluations'
      fullPath: '/admin/evaluations'
      preLoaderRoute: typeof ProtectedAdminEvaluationsIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/emails/': {
      id: '/_protected/admin/emails/'
      path: '/emails'
      fullPath: '/admin/emails'
      preLoaderRoute: typeof ProtectedAdminEmailsIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/datarooms/': {
      id: '/_protected/admin/datarooms/'
      path: '/datarooms'
      fullPath: '/admin/datarooms'
      preLoaderRoute: typeof ProtectedAdminDataroomsIndexRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/users/$id': {
      id: '/_protected/admin/users/$id'
      path: '/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof ProtectedAdminUsersIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/startups/$id': {
      id: '/_protected/admin/startups/$id'
      path: '/startups/$id'
      fullPath: '/admin/startups/$id'
      preLoaderRoute: typeof ProtectedAdminStartupsIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/prescreens/$id': {
      id: '/_protected/admin/prescreens/$id'
      path: '/prescreens/$id'
      fullPath: '/admin/prescreens/$id'
      preLoaderRoute: typeof ProtectedAdminPrescreensIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/onboarding/$id': {
      id: '/_protected/admin/onboarding/$id'
      path: '/onboarding/$id'
      fullPath: '/admin/onboarding/$id'
      preLoaderRoute: typeof ProtectedAdminOnboardingIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/investors/$id': {
      id: '/_protected/admin/investors/$id'
      path: '/investors/$id'
      fullPath: '/admin/investors/$id'
      preLoaderRoute: typeof ProtectedAdminInvestorsIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/evaluations/$id': {
      id: '/_protected/admin/evaluations/$id'
      path: '/evaluations/$id'
      fullPath: '/admin/evaluations/$id'
      preLoaderRoute: typeof ProtectedAdminEvaluationsIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/emails/$id': {
      id: '/_protected/admin/emails/$id'
      path: '/emails/$id'
      fullPath: '/admin/emails/$id'
      preLoaderRoute: typeof ProtectedAdminEmailsIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
    '/_protected/admin/datarooms/$id': {
      id: '/_protected/admin/datarooms/$id'
      path: '/datarooms/$id'
      fullPath: '/admin/datarooms/$id'
      preLoaderRoute: typeof ProtectedAdminDataroomsIdRouteImport
      parentRoute: typeof ProtectedAdminRouteRoute
    }
  }
}

interface ProtectedAdminRouteRouteChildren {
  ProtectedAdminIndexRoute: typeof ProtectedAdminIndexRoute
  ProtectedAdminDataroomsIdRoute: typeof ProtectedAdminDataroomsIdRoute
  ProtectedAdminEmailsIdRoute: typeof ProtectedAdminEmailsIdRoute
  ProtectedAdminEvaluationsIdRoute: typeof ProtectedAdminEvaluationsIdRoute
  ProtectedAdminInvestorsIdRoute: typeof ProtectedAdminInvestorsIdRoute
  ProtectedAdminOnboardingIdRoute: typeof ProtectedAdminOnboardingIdRoute
  ProtectedAdminPrescreensIdRoute: typeof ProtectedAdminPrescreensIdRoute
  ProtectedAdminStartupsIdRoute: typeof ProtectedAdminStartupsIdRoute
  ProtectedAdminUsersIdRoute: typeof ProtectedAdminUsersIdRoute
  ProtectedAdminDataroomsIndexRoute: typeof ProtectedAdminDataroomsIndexRoute
  ProtectedAdminEmailsIndexRoute: typeof ProtectedAdminEmailsIndexRoute
  ProtectedAdminEvaluationsIndexRoute: typeof ProtectedAdminEvaluationsIndexRoute
  ProtectedAdminFeedbackIndexRoute: typeof ProtectedAdminFeedbackIndexRoute
  ProtectedAdminInvestorsIndexRoute: typeof ProtectedAdminInvestorsIndexRoute
  ProtectedAdminOnboardingIndexRoute: typeof ProtectedAdminOnboardingIndexRoute
  ProtectedAdminPrescreensIndexRoute: typeof ProtectedAdminPrescreensIndexRoute
  ProtectedAdminStartupsIndexRoute: typeof ProtectedAdminStartupsIndexRoute
  ProtectedAdminUsersIndexRoute: typeof ProtectedAdminUsersIndexRoute
}

const ProtectedAdminRouteRouteChildren: ProtectedAdminRouteRouteChildren = {
  ProtectedAdminIndexRoute: ProtectedAdminIndexRoute,
  ProtectedAdminDataroomsIdRoute: ProtectedAdminDataroomsIdRoute,
  ProtectedAdminEmailsIdRoute: ProtectedAdminEmailsIdRoute,
  ProtectedAdminEvaluationsIdRoute: ProtectedAdminEvaluationsIdRoute,
  ProtectedAdminInvestorsIdRoute: ProtectedAdminInvestorsIdRoute,
  ProtectedAdminOnboardingIdRoute: ProtectedAdminOnboardingIdRoute,
  ProtectedAdminPrescreensIdRoute: ProtectedAdminPrescreensIdRoute,
  ProtectedAdminStartupsIdRoute: ProtectedAdminStartupsIdRoute,
  ProtectedAdminUsersIdRoute: ProtectedAdminUsersIdRoute,
  ProtectedAdminDataroomsIndexRoute: ProtectedAdminDataroomsIndexRoute,
  ProtectedAdminEmailsIndexRoute: ProtectedAdminEmailsIndexRoute,
  ProtectedAdminEvaluationsIndexRoute: ProtectedAdminEvaluationsIndexRoute,
  ProtectedAdminFeedbackIndexRoute: ProtectedAdminFeedbackIndexRoute,
  ProtectedAdminInvestorsIndexRoute: ProtectedAdminInvestorsIndexRoute,
  ProtectedAdminOnboardingIndexRoute: ProtectedAdminOnboardingIndexRoute,
  ProtectedAdminPrescreensIndexRoute: ProtectedAdminPrescreensIndexRoute,
  ProtectedAdminStartupsIndexRoute: ProtectedAdminStartupsIndexRoute,
  ProtectedAdminUsersIndexRoute: ProtectedAdminUsersIndexRoute,
}

const ProtectedAdminRouteRouteWithChildren =
  ProtectedAdminRouteRoute._addFileChildren(ProtectedAdminRouteRouteChildren)

interface ProtectedRouteChildren {
  ProtectedAdminRouteRoute: typeof ProtectedAdminRouteRouteWithChildren
  ProtectedCreditsRoute: typeof ProtectedCreditsRoute
  ProtectedJoinRoute: typeof ProtectedJoinRoute
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedShareRoute: typeof ProtectedShareRoute
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedInvestorsIdRoute: typeof ProtectedInvestorsIdRoute
  ProtectedPitchesPitchIdRoute: typeof ProtectedPitchesPitchIdRoute
  ProtectedPitchesNewRoute: typeof ProtectedPitchesNewRoute
  ProtectedSTokenRoute: typeof ProtectedSTokenRoute
  ProtectedUsersIdRoute: typeof ProtectedUsersIdRoute
  ProtectedPitchesIndexRoute: typeof ProtectedPitchesIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAdminRouteRoute: ProtectedAdminRouteRouteWithChildren,
  ProtectedCreditsRoute: ProtectedCreditsRoute,
  ProtectedJoinRoute: ProtectedJoinRoute,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedShareRoute: ProtectedShareRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedInvestorsIdRoute: ProtectedInvestorsIdRoute,
  ProtectedPitchesPitchIdRoute: ProtectedPitchesPitchIdRoute,
  ProtectedPitchesNewRoute: ProtectedPitchesNewRoute,
  ProtectedSTokenRoute: ProtectedSTokenRoute,
  ProtectedUsersIdRoute: ProtectedUsersIdRoute,
  ProtectedPitchesIndexRoute: ProtectedPitchesIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SlugRoute: SlugRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  LivekitEgressTemplateRoute: LivekitEgressTemplateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
